import React, { useState } from "react";
import { downloadAdminReport } from "../../../services/attendanceApi";
import Icons from "./Icons";

/**
 * ReportExport — admin exports attendance reports as PDF or Excel,
 * with filters: date range and individual employee (by internal UUID).
 * NOTE: the backend has no department column, so there is no Department
 * filter — it was removed to avoid confusing admins with a no-op field.
 * The backend returns a download URL (or base64); we trigger a download.
 */
function ReportExport() {
  const [filters, setFilters] = useState({ fromDate: "", toDate: "", userId: "" });
  const [busy, setBusy] = useState("");
  const [error, setError] = useState("");

  const set = (k, v) => setFilters((f) => ({ ...f, [k]: v }));

  const doExport = async (format) => {
    setError("");
    setBusy(format);
    try {
      // Drop empty filters
      const clean = {};
      Object.entries(filters).forEach(([k, v]) => { if (v) clean[k] = v; });
      // Backend streams a real PDF/Excel file — download it directly.
      await downloadAdminReport(format, clean);
    } catch (err) {
      setError(err.message || "Could not generate report.");
    } finally {
      setBusy("");
    }
  };

  return (
    <div className="atl-card atl-reports">
      <h3><span className="atl-h3ic">{Icons.report}</span>Export Attendance Report</h3>
      {error && <div className="atl-error">{error}</div>}

      <div className="atl-row">
        <div className="atl-field"><label>From Date</label><input type="date" className="atl-input" value={filters.fromDate} onChange={(e) => set("fromDate", e.target.value)} /></div>
        <div className="atl-field"><label>To Date</label><input type="date" className="atl-input" value={filters.toDate} onChange={(e) => set("toDate", e.target.value)} /></div>
      </div>
      <div className="atl-row">
        <div className="atl-field"><label>User ID (UUID, optional)</label><input className="atl-input" value={filters.userId} onChange={(e) => set("userId", e.target.value)} placeholder="Internal user UUID — not the employee ID" /></div>
      </div>

      <div className="atl-reports__actions">
        <button className="atl-btn atl-btn--primary" onClick={() => doExport("pdf")} disabled={!!busy}><span className="atl-btnic">{Icons.pdf}</span>{busy === "pdf" ? "Generating..." : "Export PDF"}</button>
        <button className="atl-btn atl-btn--secondary" onClick={() => doExport("excel")} disabled={!!busy}><span className="atl-btnic">{Icons.excel}</span>{busy === "excel" ? "Generating..." : "Export Excel"}</button>
      </div>
      <p className="atl-hint">Leave date fields empty to export the current month. Filters are optional.</p>
    </div>
  );
}

export default ReportExport;
